import { axios } from "../../lib/axios";


export const ApplyCoupon = (code: string): Promise<object> => {
    return axios.post(`/coupon/applyCoupon/${encodeURIComponent(code.trim())}`)
        .then(response => response.data as object);
};
